import React, { FC, useState } from 'react';
import { Input, Dropdown } from 'semantic-ui-react';
import { VOICE_MODELS, VOICE_PROVIDERS, InworldVoiceSettings } from '../../../../core/api/VoiceConfig';
import { SettingsContainer, SettingRow, Label, SliderContainer, ValueDisplay } from './styles';

export interface Props {
  settings: InworldVoiceSettings;
  onChange: (settings: InworldVoiceSettings) => void;
}

export const InworldSettings: FC<Props> = ({ settings, onChange }) => {
  const handleChange = (key: keyof InworldVoiceSettings, value: any) => {
    onChange({
      ...settings,
      [key]: value
    });
  };

  const handleOptionChange = (key: keyof InworldVoiceSettings["options"], value: any) => {
    onChange({
      ...settings,
      options: {
        ...settings.options,
        [key]: value
      }
    });
  };

  const handleModelChange = (value: string) => {
    handleChange('model', value);
  };


  const modelOptions = VOICE_MODELS[VOICE_PROVIDERS.INWORLD].map(model => ({
    key: model.id,
    value: model.id,
    text: model.name
  }));

  const selectedModel = VOICE_MODELS[VOICE_PROVIDERS.INWORLD].find(m => m.id === settings.model)
    ? settings.model
    : 'inworld-tts-1';

  return (
    <SettingsContainer>
      <SettingRow>
        <Label>Model</Label>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{ flex: 1 }}>
            <Dropdown
              selection
              fluid
              options={modelOptions}
              value={selectedModel}
              onChange={(_, { value }) => handleModelChange(value as string)}
            />
          </div>
        </div>
      </SettingRow>

      <SettingRow>
        <SliderContainer>
          <Label>Speed</Label>
          <Input
            type="range"
            min={0.5}
            max={1.5}
            step={0.1}
            value={settings.speed}
            onChange={(e) => handleChange('speed', parseFloat(e.target.value))}
          />
          <ValueDisplay>{settings.speed.toFixed(1)}</ValueDisplay>
        </SliderContainer>
      </SettingRow>

      <SettingRow>
        <Label>Temperature</Label>
        <Input
          type="range"
          min={0}
          max={2}
          step={0.1}
          value={settings.options.temperature}
          onChange={(e) => handleOptionChange('temperature', parseFloat(e.target.value))}
        />
        <ValueDisplay>{settings.options.temperature.toFixed(1)}</ValueDisplay>
      </SettingRow>

      <SettingRow>
        <Label>Pitch</Label>
        <Input
          type="range"
          min={-5}
          max={5}
          step={0.1}
          value={settings.options.pitch}
          onChange={(e) => handleOptionChange('pitch', parseFloat(e.target.value))}
        />
        <ValueDisplay>{settings.options.pitch.toFixed(1)}</ValueDisplay>
      </SettingRow>
    </SettingsContainer>
  );
}; 